import { render, staticRenderFns } from "./TotalrecdetailReportDetail.vue?vue&type=template&id=262f71db"
import script from "./TotalrecdetailReportDetail.vue?vue&type=script&lang=js"
export * from "./TotalrecdetailReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports